import type { NodeGroupOption, WorkflowType } from '@lighthouse/shared'

export const filterList = (list: NodeGroupOption[], search: string, workflowType?: WorkflowType): NodeGroupOption[] => {
    const lowerCaseSearch = search.toLowerCase()

    return list.reduce<NodeGroupOption[]>((acc, item) => {
        const isMatch = item.label.toLowerCase().includes(lowerCaseSearch)

        const filteredChildren = item.children?.filter(
            child => child.label.toLowerCase().includes(lowerCaseSearch) && workflowType && child.auth.includes(workflowType)
        )

        if ((isMatch || (filteredChildren && filteredChildren.length > 0)) && filteredChildren.length) {
            acc.push({
                ...item,
                children: filteredChildren
            })
        }

        return acc
    }, [])
}
